import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceLocationApiService {

  constructor(private http: HttpClient) { }

  readonly deviceLocationUrl: string = 'identity/location';

  public getDeviceLocation(): Observable<any> {
    return this.http.get(this.deviceLocationUrl);
  }

  public updateDeviceLocation(deviceLocationConfiguration): Observable<any> {
    return this.http.put(this.deviceLocationUrl, deviceLocationConfiguration);
  }
}
